"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPORT_INTERVALS = void 0;
exports.IMPORT_INTERVALS = [
    60, 120, 180, 360, 720, 1440, 2880, 4320, 10080,
];
